export const name = 'impositionPreviewZoominDirective';
export default function impositionPreviewZoominDirective() {
//noinspection BadExpressionStatementJS
    'ngInject';

    var directive = {
        restrict: 'E',
        template: require('./impositionPreviewZoomin.html'),
        scope: {

        },

        controller: impositionPreviewZoominController,
        controllerAs: 'vm',
        bindToController: true
    };

    return directive;
}


function impositionPreviewZoominController($q, $scope, $stateParams, stateKeeperService, breadCrumbsCreatorFactory, ImageUrlCreatorFactory,
                                                          CachingFactory, $interval, templatesService, $window, breadcrumbsService) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var vm = this;
    vm.pageTitle = null;
    vm.isInitializationComplete = false;
    vm.composerTemplateId = null;
    vm.dataStorageId = null;
    vm.templateName = null;
    vm.dataFileName = null;
    vm.assetsLibrariesStorageIds = null;
    vm.imageSource = null;
    vm.totalSheets = null;
    vm.cache = null;
    vm.isDuplex = null;
    vm.side = null;
    vm.sheetNumber = null;

    vm.onPlus = onPlus;
    vm.plusDisabled = true;

    vm.onMinus = onMinus;
    vm.minusDisabled = true;

    vm.fitToPage = fitToPage;
    vm.fitToPageDisabled = true;

    vm.rotatePage = rotatePage;
    vm.rotateDisabled = true;

    vm.triggerZoomIn = false;
    vm.triggerZoomOut = false;
    vm.reset = false;
    vm.rotate = 0;
    vm.isPageLoaded = false;

    vm.onSideSelected = onSideSelected;
    vm.sideSelector = "left";

    vm.onNavigatorChange = onNavigatorChange;

    vm.onImageLoaded = onImageLoaded;

    vm.onZoomChange = onZoomChange;

    vm.onImageRetry = onImageRetry;

    let stateParams = angular.copy($stateParams);

    initialize();

    function initialize(){
        breadcrumbsService.isBreadcrumbsFeatureEnabled().then(isNewBreadcrumbsActivated => {
          if(!isNewBreadcrumbsActivated) {
            vm.breadcrumbs = breadCrumbsCreatorFactory.createBreadCrumbs();
          }
        });

        let defer = $q.defer();
        if(stateParams.data) {
          setStateParams();
          arrangeZoomInSpace();

          if (vm.dataFileName === undefined || vm.dataFileName === null || vm.dataFileName === 'null') {
            vm.pageTitle = vm.templateName + ".pdf";
          } else {
            vm.pageTitle = vm.templateName + vm.dataFileName + ".pdf";
          }

          if(vm.cache === null) {
            vm.cache = CachingFactory.createCachingObject();
            vm.side = 'A';
            vm.sheetNumber = 1;
            uploadDataAndCreateImage().then(response => {
              defer.resolve();
            }, error => {
              defer.reject();
            });
          }else{
            let cacheEntry = getCachingEntry(vm.sheetNumber - 1);

            if(cacheEntry !== undefined && cacheEntry.state === "successful") {
              // might be that the image was already created in the past - in that case switch to it
              vm.imageSource = extractImageUrlFromImageRequestResult(getCachingEntry(vm.sheetNumber - 1).url);
              vm.isInitializationComplete = true;
              defer.resolve();
            }else{
              uploadDataAndCreateImage().then(response => {
                defer.resolve();
              }, error => {
                defer.reject();
              });
            }
          }
        }else{
          defer.resolve();
        }
        return defer.promise;

        function uploadDataAndCreateImage(){
          let defer = $q.defer();
          uploadData().then(
            function (dataStorageId) {
              vm.dataStorageId = dataStorageId;
              createCurrentImage(true).then(
                function (result) {
                  vm.totalSheets = extractTotalSheetsFromImageRequestResult(result);
                  vm.isInitializationComplete = true;
                  defer.resolve();
                },
                function () {
                  // do nothing - the createCurrentImage will put error url in place
                  vm.imageSource = "error";
                  defer.reject();
                }
              );
            },
            function () {
              // in this case - we need to set error url so user can try again including initialization stage.
              setCurrentWithErrorUrl();
              vm.imageSource = "error";
              defer.reject();
            }
          );
          return defer.promise;
        }
    }

    function setStateParams(){
        vm.composerTemplateId = stateParams.composerTemplateId;
        vm.isDuplex = stateParams.isDuplex;
        vm.data = stateParams.data;
        vm.sheetNumber = stateParams.sheetNumber;
        vm.templateName = stateParams.templateName;
        vm.dataFileName = decodeURIComponent(stateParams.dataFileName);
        vm.assetsLibrariesStorageIds = stateParams.assetsLibrariesStorageIds;
    }

    function uploadData(){
        return templatesService.uploadData(vm.data);
    }


    function createCurrentImage(isMetadataNeeded = false){
        vm.imageSource = null;

        let defer = $q.defer();

        ImageUrlCreatorFactory.createImage(vm.cache, getCurrentCachingIndex(), {
            side:vm.side, sheetNumber:vm.sheetNumber} ,function() {
                return requestSpreadImage(getCurrentSpreadNumber(), isMetadataNeeded);
            },
            function(_cachingIndex, identity){
                if(identity.side === vm.side && identity.sheetNumber === vm.sheetNumber){
                    vm.imageSource = extractImageUrlFromImageRequestResult(getCachingEntry(_cachingIndex).url);
               }
                defer.resolve(getCachingEntry(_cachingIndex).url);
            },
            function(_cachingIndex, identity){
                if(identity.side === vm.side && identity.sheetNumber === vm.sheetNumber){
                    vm.imageSource = "error"; // "error" url
                }
                defer.reject();
            });

        return defer.promise;
    }


    function requestSpreadImage(spreadNumber, isMetaDataNeeded){
        let imposedSpreadRequest = {
            cacheCellRequests:[{recordData:[spreadNumber]}],
            dataStorageId:vm.dataStorageId,
            fetchMetadataInfo:isMetaDataNeeded,
        };
        return templatesService.fetchImposedSpread(vm.composerTemplateId, imposedSpreadRequest, vm.templateName, vm.dataFileName, vm.assetsLibrariesStorageIds, true);
    }

    function setCurrentWithErrorUrl(){
        vm.cache.add(getCurrentCachingIndex(),{url:{cellWithImageStorageId:[{storageId:"error"}]} ,status:"error"});
    }

    function extractImageUrlFromImageRequestResult(imageRequestResult){
        return imageRequestResult.cellWithImageStorageId[0].storageId;
    }

    function extractTotalSheetsFromImageRequestResult(imageRequestResult){
        return imageRequestResult.metadataInfo.jobNumSheets;
    }

    function getCurrentCachingIndex(){
        return vm.isDuplex ? (vm.side === "A" ? (vm.sheetNumber - 1)*2 :  (vm.sheetNumber - 1)*2 + 1) : vm.sheetNumber - 1;
    }

    function getCurrentSpreadNumber(){
        return vm.isDuplex ?  (vm.side === "A" ? (vm.sheetNumber - 1)*2 + 1 : (vm.sheetNumber - 1)*2 + 2) : vm.sheetNumber;
    }

    function getCachingEntry(cachingIndex){
        return vm.cache.get(cachingIndex);
    }


    function onPlus(){
        vm.triggerZoomIn = true;
    }

    function onMinus(){
        vm.triggerZoomOut = true;
    }

    function fitToPage(){
        vm.reset = true;
    }

    function rotatePage(){
        let newRotation = vm.rotate;
        newRotation += 90;
        if(newRotation === 360){
            newRotation = 0;
        }
        vm.rotate = newRotation;
    }

    function onZoomChange(zoomLevel){
        if(zoomLevel === 100){
            vm.minusDisabled = true;
            vm.plusDisabled = false;
        }else{
            vm.minusDisabled = false;
            vm.plusDisabled = false;
        }
    }

    function onImageRetry(){
        vm.imageSource = null;
        if(vm.isInitializationComplete === false){
            initialize().then(
                function(){
                    onNavigatorChange(vm.sheetNumber, vm.side);
                },
                function(){
                    // do nothing - initialize take care for that
                });
        }else{
            onNavigatorChange(vm.sheetNumber, vm.side);
        }


    }

    function onSideSelected(selectedSide){
        setSelectedSide(selectedSide);
        onNavigatorChange(vm.sheetNumber, vm.side);
    }

    function onNavigatorChange(current, side = null){
        vm.imageSource = null;
        vm.sheetNumber = current;
        vm.fitToPageDisabled = true;
        vm.rotateDisabled = true;
        vm.minusDisabled = true;
        vm.plusDisabled = true;

        if(side === null){
            side = vm.side;
        }

        // wait for a second as it might be that user is only passing through
        $interval(function(){
            // we are still at the same one selected by user
            if(vm.sheetNumber === current && vm.side === side){
                let cachingIndex = getCurrentCachingIndex();
                let cacheEntry = getCachingEntry(cachingIndex);

                if(cacheEntry !== undefined && cacheEntry.state === "successful"){
                    // might be that the image was already created in the past - in that case switch to it
                    vm.imageSource = extractImageUrlFromImageRequestResult(getCachingEntry(cachingIndex).url);
                }else if(cacheEntry === undefined || cacheEntry.state === "error"){
                    // in case the image was never requested or, in case it was requested but returned with error in the past - then request it
                    createCurrentImage();
                }else{
                    // if we are here then it means that the entry is defined, and the status is requested - in this case just wait for it - set the image to null
                    vm.imageSource = null;
                }
            }

        },1000,1);
    }

    function onImageLoaded(){
        vm.fitToPageDisabled = false;
        vm.rotateDisabled = false;
        vm.minusDisabled = true;
        vm.plusDisabled = false;
    }

    function setSelectedSide(selectedSide){
        if(selectedSide === 'A' || selectedSide === 'B'){
            vm.side = selectedSide;
            vm.sideSelector = selectedSide === 'A' ? 'left' : 'right';
        }else{
            vm.side = selectedSide === 'left' ? 'A' : 'B';
            vm.sideSelector = selectedSide;
        }
    }

    // check occupied space and how left for the image zoom in
    function arrangeZoomInSpace(){
        vm.pageParentElement = angular.element(document.getElementById("composer-imposed-zoom-in-view-page"));

        let AllInternalPageElementIds = [
            "composer-imposed-zoom-in-view-page-toolbar",
            "composer-imposed-zoom-in-view-page-nav",
            "composer-imposed-zoom-in-view-page-nav-txt"
        ];

        if(vm.isDuplex){
            AllInternalPageElementIds.push("composer-imposed-zoom-in-view-page-right-left");
        }

        let upperRibbonSpace = 0;
        let upperRibbon = document.getElementById('upper-ribbon-wrapper');
        if(upperRibbon !== null){
          upperRibbonSpace = upperRibbon.getBoundingClientRect().height + 10;
        }

        $interval(function(){
            if(vm.pageParentElement.children().length === AllInternalPageElementIds.length){
                let totalHeight =  vm.pageParentElement[0].getBoundingClientRect().height;
                let subAndStatus = getElementsHeightSum(AllInternalPageElementIds);
                if(subAndStatus.isAllLoaded){
                    vm.nonAvailableSpaceForPreview = subAndStatus.sum + ($window.innerHeight - totalHeight) + upperRibbonSpace + 20;
                    vm.isPageLoaded = true;
                }
            }
        },500,0);
    }

    function getElementsHeightSum(elementIds){
        let sum = 0;
        let isAllNotZero = true;
        for(let iElement = 0; iElement < elementIds.length; iElement++){
            let element =  angular.element(document.getElementById(elementIds[iElement]));
            if(element !== undefined && element !== null && element[0] !== undefined && element[0] !== null){
                let elementHeight = element[0].getBoundingClientRect().height;
                sum += elementHeight;
                if(elementHeight === 0){
                    isAllNotZero = false;
                }
            }else{
                isAllNotZero = false;
            }
        }
        return {sum:sum, isAllLoaded:isAllNotZero};
    }

    $scope.$on('$stateChangeStart', function (ev, to, toParams, from, fromParams) {
      //assign the "from" parameter to something
      if(from.name === 'templates.templatedetails.imposedpreview') {
        let stateToKeep = {
          stateParams: stateParams,
          sheetNumber: vm.sheetNumber,
          dataStorageId: vm.dataStorageId,
          totalSheets: vm.totalSheets,
          side: vm.side,
          cache: vm.cache
        };
        stateKeeperService.keepState('templates.templatedetails.imposedpreview', stateToKeep);
      }
    });

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
      //assign the "from" parameter to something
      if(!$stateParams.data) {
        let stateToRestore = stateKeeperService.getState('templates.templatedetails.imposedpreview');
        stateParams = stateToRestore.stateParams;
        stateParams.recordNumber = stateToRestore.recordNumber;
        stateParams.sheetNumber = stateToRestore.sheetNumber;
        vm.dataStorageId = stateToRestore.dataStorageId;
        vm.side = stateToRestore.side;
        vm.totalSheets = stateToRestore.totalSheets;
        vm.cache = stateToRestore.cache;
        initialize();
      }
    });
}

